import React, { ReactNode, useRef, useState } from 'react';
import cx from 'classnames';
import { shortenAddress } from 'utils/helper';

import arrowIcon from './utils/images/arrow.svg';

interface Props {
  items: string[];
  names?: string[];
  addresses: string[];
  item?: string;
  address?: string;
  itemMap?: (val: string) => string;
  onChange: (el: string) => void;
  loading?: boolean;
  id?: string;
  fullWidth?: boolean;
  fullOpcity?: boolean;
  disabledOnLoading?: boolean;
  actionBottom?: ReactNode | JSX.Element;
}

export const SubAccountsDropdown: React.FC<Props> = ({
  items,
  names,
  addresses,
  item,
  onChange,
  loading,
  id,
  disabledOnLoading,
  fullWidth = false,
  fullOpcity,
  itemMap,
  actionBottom,
}) => {
  const [open, setOpen] = useState(false);
  const disabledOnLoadingRef = useRef(disabledOnLoading);
  disabledOnLoadingRef.current = disabledOnLoading;

  const handleChange = (el: string) => {
    onChange(el);
    setOpen(false);
  };

  const selectedNameItemIndex = items?.findIndex((el) => el === item);

  return (
    <div className="relative w-full">
      <div
        className={cx(
          'flex items-center justify-between rounded-[8px] py-[6px] px-12 border-[.5px] border-black-4 h-32',
          open ? 'bg-white-10' : 'bg-white-3'
        )}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((prevState) => !prevState);
        }}
      >
        <div className="text-m12">{names?.[selectedNameItemIndex]}</div>
        <div className="flex items-center gap-4">
          <span className="text-r12 text-regular">
            {shortenAddress(addresses[selectedNameItemIndex])}
          </span>
          <img
            src={arrowIcon}
            alt=""
            className={cx('transition-transform', !open && 'rotate-180')}
          />
        </div>
      </div>
      {open && (
        <div
          className="fixed inset-0 z-10"
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
          }}
        />
      )}
      {open && (
        <div className="absolute z-50 rounded-[8px] bg-white-10 border-[.5px] border-white-10 backdrop-blur-lg py-8 flex flex-col gap-8 w-full mt-4">
          {items.map((el, index) => {
            const nameItem = names?.[index];
            const addressItem = addresses[index];

            return (
              <div
                key={el}
                className="flex items-center justify-between hover:bg-white-10 px-16 py-8 transition-all"
                onClick={(e) => {
                  e.stopPropagation();
                  handleChange(el);
                }}
              >
                {nameItem && <div className="text-m12">{nameItem}</div>}
                <div className="flex items-center">
                  <span className="text-r12 text-regular">{shortenAddress(addressItem)}</span>
                </div>
              </div>
            );
          })}
          {actionBottom && (
            <div className="z-100">
              <div className="bg-white-10 h-[.5px]" />
              {actionBottom}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
